import {
  GET_PERFORMANCESCORE,
  GET_PERFORMANCESCORE_SUCCESS,
  GET_PERFORMANCESCORE_FAIL,
  DELETE_PERFORMANCESCORE,
  DELETE_PERFORMANCESCORE_SUCCESS,
  DELETE_PERFORMANCESCORE_FAIL,
  UPDATE_PERFORMANCESCORE,
  UPDATE_PERFORMANCESCORE_SUCCESS,
  UPDATE_PERFORMANCESCORE_FAIL,
  ADD_NEW_PERFORMANCESCORE,
  ADD_PERFORMANCESCORE_SUCCESS,
  ADD_PERFORMANCESCORE_FAIL,
  PERFORMANCESCORE_LOADING,
  PERFORMANCESCORE_RESET,
} from "./actionType";

export const resetPerformanceScoreState = (actionType) => ({
  type: PERFORMANCESCORE_RESET,
  payload: { actionType },
});

export const getPerformanceScoreSuccess = (actionType, data) => ({
  type: GET_PERFORMANCESCORE_SUCCESS,
  payload: { actionType, data },
});

export const getPerformanceScoreFail = (actionType, error) => ({
  type: GET_PERFORMANCESCORE_FAIL,
  payload: { actionType, error },
});

export const getPerformanceScore = data => ({
  type: GET_PERFORMANCESCORE,
  payload: data,
});

export const getPerformanceScoreLoading = () => ({
  type: PERFORMANCESCORE_LOADING
});

export const deletePerformanceScore = data => ({
  type: DELETE_PERFORMANCESCORE,
  payload: data,
});

export const deletePerformanceScoreSuccess = data => ({
  type: DELETE_PERFORMANCESCORE_SUCCESS,
  payload: data,
});

export const deletePerformanceScoreFail = error => ({
  type: DELETE_PERFORMANCESCORE_FAIL,
  payload: error,
});

export const updatePerformanceScore = data => ({
  type: UPDATE_PERFORMANCESCORE,
  payload: data,
});

export const updatePerformanceScoreFail = error => ({
  type: UPDATE_PERFORMANCESCORE_FAIL,
  payload: error,
});

export const updatePerformanceScoreSuccess = data => ({
  type: UPDATE_PERFORMANCESCORE_SUCCESS,
  payload: data,
});

export const addNewPerformanceScore = data => ({
  type: ADD_NEW_PERFORMANCESCORE,
  payload: data,
});

export const addPerformanceScoreSuccess = data => ({
  type: ADD_PERFORMANCESCORE_SUCCESS,
  payload: data,
});

export const addPerformanceScoreFail = error => ({
  type: ADD_PERFORMANCESCORE_FAIL,
  payload: error,
});